import React from "react";
import './sdBtn.scss';

function SDBtn (props) {
    switch (props.type) {
        case 'arrow':
            return (
                <div className={`arrow ${props.direction}`}  onClick={e => {props.click()}}>
                    <div className={'effect'}></div>
                </div>
            )
        default:
            return (
                <div className={'mainBody'}>
                    <button style={props.cstyle} onClick={e => {props.click()}}>{props.label}</button>
                </div>
            )
    }

}

export default SDBtn;